module.exports = __webpack_public_path__ + "static/media/document-logo.78749320.jpg";